import type { HTMLAttributes } from 'react';

export type BadgeTone = 'success' | 'warning' | 'error' | 'neutral';

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: BadgeTone;
};

export function Badge({ tone = 'neutral', className, children, ...props }: BadgeProps) {
  return (
    <span
      {...props}
      className={['hopper-badge', `hopper-badge--${tone}`, className].filter(Boolean).join(' ')}
    >
      {children}
    </span>
  );
}
